
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import {
  SidebarMenu,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar"
import { useAuthStore } from "@/stores/authStore"
import { useProfile } from "@/hooks/useProfile"
import { toast } from "sonner"
import { UserMenuContent } from "./user-menu-content"
import { UserMenuTrigger } from "./user-menu-trigger"

interface NavUserProps {
  user: {
    name: string
    email: string
    avatar: string
  }
}

export function NavUser({ user }: NavUserProps) {
  const { isMobile } = useSidebar()
  const { signOut, user: authUser } = useAuthStore()
  const { profile, isLoading } = useProfile(authUser)

  const handleSignOut = async () => {
    try {
      await signOut()
      // Removed duplicate toast - AuthContext already handles this
    } catch (error) {
      console.error("Error signing out:", error)
      toast.error("Failed to log out")
    }
  }

  if (isLoading) {
    return null; // Or a loading spinner if preferred
  }

  const displayName = profile?.first_name || "Welcome"
  const displayEmail = authUser?.email || user.email
  const avatarUrl = profile?.avatar_url || ""

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild className="w-full">
            <UserMenuTrigger 
              user={{
                name: displayName,
                email: displayEmail,
                avatar: avatarUrl
              }} 
            />
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-56 rounded-lg z-50"
            side={isMobile ? "bottom" : "right"}
            align="end"
            sideOffset={4}
            role="menu"
            aria-label="User menu"
          >
            <UserMenuContent 
              user={{
                name: displayName,
                email: displayEmail,
                avatar: avatarUrl
              }} 
              onSignOut={handleSignOut} 
            />
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
